<template>
  <v-card class="elevation-12">
    <v-toolbar color="white" dense>
      <img
        src="@/assets/logo.jpg"
        height="36px"
        width="200px"
        alt=""
        class="mr-3"
      />
      <v-icon color="primary">person</v-icon>
      <v-toolbar-title>Reset Password</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-progress-linear
        v-show="connecting"
        :indeterminate="true"
      ></v-progress-linear>
      <v-alert
        :value="message !== null"
        type="error"
        dismissible
        transition="scale-transition"
        v-if="!emailSent && message !== null"
      >
        {{ message }}
      </v-alert>
      <v-alert v-model="error" type="error" dismissible icon="warning" dark>
        {{ errorText }}
      </v-alert>
      <v-text-field
        :disabled="connecting"
        id="username"
        name="username"
        :rules="emailRules"
        type="email"
        label="Enter your email address"
        v-model="email"
        prepend-icon="email"
        class="input-group--focused"
        v-if="!emailSent"
        required
      >
      </v-text-field>
      <p v-if="emailSent">Check out your email for more instructions</p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        @click="$router.push({ name: 'signIn' })"
        flat
        color="primary"
        :disabled="connecting"
      >
        <v-icon left dark>arrow_back</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-btn
        @click="submit"
        round
        color="primary"
        v-if="!emailSent"
        :disabled="!valid || connecting"
      >
        Send
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
/*#sign-in-card {
      position: absolute;
      right: 15px;
      top: 85px;
      width: 30%;
  }*/
</style>
<script type="text/javascript">
export default {
  name: 'Blank',
  props: {
    message: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      passwordVisibilityOff: true,
      error: null,
      emailSent: false,
      errorText: '',
      email: '',
      emailRules: [v => !!v || 'Enter a valid email'],
      password: '',
      passwordRules: [v => !!v || 'Password is required'],
      connecting: false
    }
  },
  computed: {
    valid() {
      return this.email
    }
  },
  methods: {
    submit() {
      // Native form submission is not yet supported
      this.error = false
      this.connecting = true
      this.axios
        .post('password/create', {
          email: this.email
        })
        .then(response => {
          this.connecting = false
          this.emailSent = true
          this.$notify({
            group: 'all',
            title: 'Email Sent',
            text: 'Check your email for more instructions!'
          })
        })
        .catch(error => {
          this.connecting = false
          this.emailSent = false
          this.$app.log(error)
          this.error = true
          this.connecting = false
          if (error.code === 404) {
            this.errorText = error.response.data.message
          } else {
            this.errorText = 'An error occurred: ' + error.message
          }
        })
    }
  }
}
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/ResetPassword.vue